export default __webpack_public_path__ + "static/media/logo_parceiro_01.fc9fc74b.svg";